<template>
    <div class="underage-wrap"
        :class="{ page: page === 'email' || page === 'verify', m: !$utils.isPC, [$i18n.locale]: true }">
        <template v-if="page === 'tip'">
            <div class="head">
                <div class="back" @click="back"></div>
                {{ $t('underage_tip_7') }}
            </div>
            <div class="tips">{{ msg_tip }}</div>
            <div class="btn-wrap">
                <button class="btn-no" :class="{ 'disabled': loading }" @click="goSendEmail()">
                    {{ $t('underage_no') }}
                </button>
                <button class="btn-yes" :class="{ 'disabled': loading || cdSend > 0 }"
                    @click="goSendCode({ is_adult: 1 })">
                    {{ $t('underage_yes') }} {{ cdSend > 0 ? `(${cdSend}S)` : '' }}
                    <span v-if="loading" class="loading"></span>
                </button>
            </div>
        </template>
        <template v-else-if="page === 'email'">
            <div class="head">
                <div class="back" @click="emailBack"></div>
                {{ $t('underage_tip_8') }}
            </div>
            <div class="tips">{{ msg_tip }}</div>
            <Input v-model.trim="account" class="email" size="large" :placeholder="$t('underage_tip_10')" />
            <button class="send" :class="{ 'disabled': loading || cd > 0 || !this.account }" @click="sendEmail()">
                {{ $t('test_confirm') }} {{ cd > 0 ? `(${cd}S)` : '' }}
                <span v-if="loading" class="loading"></span>
            </button>
        </template>
        <template v-else-if="page === 'verify'">
            <div class="head">
                <div class="back" @click="verifyBack"></div>
                {{ $t('underage_tip_8') }}
            </div>
            <div class="tips" v-html="$t('underage_tip_1').replace(`\{\{john123@gmail.com\}\}`, account)">
            </div>
            <button class="send" :class="{ 'disabled': loading }" @click="isVerified()">
                {{ $t('underage_tip_9') }}
                <span v-if="loading" class="loading"></span>
            </button>
        </template>
    </div>
</template>

<script>
import { sendCode, sendCodeToParent } from '../api'
import { VerifySM } from '../utils/SMCaptcha'
export default {
    name: 'OauthUnderage',
    data() {
        return {
            account: '',
            page: 'tip',
            cd: 0,
            cdtimer: null,
            cdSend: 0,
            cdtimerSend: null,
            loading: false,
            msg_tip: this.$route.query.msg,
            routerParams: {
                from: this.$route.query.from,
                loginType: this.$route.query.loginType
            },
        }
    },
    created() {
        this.countdown()
    },
    methods: {
        back() {
            this.$router.back()
        },
        emailBack() {
            this.page = 'tip'
            this.account = ''
        },
        countdown() {
            if (this.cdtimer) {
                clearInterval(this.cdtimer)
                this.cdtimer = null
            }
            if (this.cdtimerSend) {
                clearInterval(this.cdtimerSend)
                this.cdtimerSend = null
            }
            const now = Math.ceil(new Date().getTime() / 1000)
            const sendParentTime = window.localStorage.getItem('sendParentTime') || 0
            const sendTime = window.localStorage.getItem('sendTime') || 0
            const cd = 60 - (now - sendParentTime)
            const cdSend = 60 - (now - sendTime)
            if (cd > 0) {
                this.cd = cd
                this.cdtimer = setInterval(() => {
                    if (this.cd === 0) {
                        clearInterval(this.cdtimer)
                        this.cdtimer = null
                    }
                    this.cd -= 1
                }, 1000)
            }
            if (cdSend > 0) {
                this.cdSend = cdSend
                this.cdtimerSend = setInterval(() => {
                    if (this.cdSend === 0) {
                        clearInterval(this.cdtimerSend)
                        this.cdtimerSend = null
                    }
                    this.cdSend -= 1
                }, 1000)
            }
        },
        verifyBack() {
            this.page = 'email'
            this.countdown()
        },
        isVerified() {
            this.goSendCode({ child_finish_valid: 1 })
        },
        sendEmail(verifyData) {
            if (this.loading) return
            if (this.cd > 0) return
            if (!this.account) return
            this.loading = true
            const params = JSON.parse(this.$route.query.params)
            if (verifyData) {
                params.verify_data = verifyData
                params.captcha_channel = 'sm'
            }
            sendCodeToParent({ ...params, parent_email: this.account })
                .then(() => {
                    this.loading = false
                    this.page = 'verify'
                    window.localStorage.setItem('sendParentTime', Math.floor(new Date().getTime() / 1000))
                })
                .catch((err) => {
                    if (err.code === 110011) {
                        VerifySM(data => {
                            if (data.pass) {
                                this.sendEmail(data)
                            }
                        })
                    } else {
                        this.$msg.success(err.msg, 3000)
                    }
                    this.loading = false
                })
        },
        goSendEmail() {
            this.page = 'email'
            this.countdown()
        },
        goSendCode(extraParam, verifyData) {
            if (this.loading || this.cdSend > 0) return
            this.loading = true
            const params = JSON.parse(this.$route.query.params)
            if (verifyData) {
                params.verify_data = verifyData
                params.captcha_channel = 'sm'
            }
            sendCode({ ...params, ...extraParam })
                .then(() => {
                    delete params.verify_data
                    delete params.captcha_channel
                    window.localStorage.setItem('sendTime', Math.floor(new Date().getTime() / 1000))
                    this.loading = false
                    this.$router.push({
                        name: 'OauthVerify',
                        query: {
                            ...params,
                            ...this.routerParams
                        }
                    })
                })
                .catch(err => {
                    if (err.code === 110011) {
                        VerifySM(data => {
                            if (data.pass) {
                                this.goSendCode(extraParam, data)
                            }
                        })
                    } else {
                        this.$msg.success(err.msg, 3000)
                    }
                    this.loading = false
                })
        }
    }
}
</script>

<style lang='less' scoped>
.underage-wrap {
    width: 100%;
    height: 100%;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    &.page {
        height: 400px !important;
        padding: 15px 28px 25px 28px;
    }

    &.m {
        height: 100% !important;
        padding: 0 30px 20px 30px;
        justify-content: center;
        gap: 40px;

        .btn-wrap {
            margin: 10px 0;
        }

        .email {
            margin-top: -20px;
        }
    }

    .head {
        position: relative;
        margin: 0 -30px;
        width: calc(100% + 60px);
        text-align: center;
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        padding: 15px 40px 0;
        font-size: 20px;
        font-weight: 600;
        color: #001111;
        line-height: 1.5;

        .back {
            position: fixed;
            width: 16px;
            height: 14px;
            background: url(~@img/icon_back.png) center center no-repeat;
            background-size: 100% 100%;
            top: 20px;
            left: 16px;
            cursor: pointer;
        }
    }

    .tips {
        font-size: 16px;
        color: #4b4b4b;
    }

    /deep/ .ivu-input-wrapper .ivu-input.ivu-input-large {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    &.fr,
    &.vi,
    &.ru {
        /deep/ .ivu-input-wrapper .ivu-input.ivu-input-large {
            font-size: 14px;
        }
    }

    .btn-wrap {
        margin: 20px 0;
        display: flex;
        flex-direction: row;

        >button {
            width: 160px;
            height: 38px;
            margin: 0 10px;
            border-radius: 8px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .btn-no {
            background: #FFFFFF;
            border: 1px solid #D3D3D3;
            color: #FE6917;
        }

        .btn-yes {
            background: #FE6917;
            color: #FFFFFF;
            border: 1px solid #ffffff00;
        }
    }

    .send {
        min-width: 210px;
        height: 42px;
        padding: 0 20px;
        margin-top: 5px;
        background: #FE6917;
        border-radius: 5px;
        color: white;
        border: 1px solid #ffffff00;
        font-size: 18px;
        cursor: pointer;
    }

    .disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .loading {
        opacity: 0.4;
        display: inline-block;
        width: 18px;
        height: 18px;
        background-image: url(~@img/icon_loading.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        transform-origin: center;
        margin-left: 10px;
        animation: ani-load-loop 2s linear infinite;
    }
}
</style>